import axios from "axios";

const client = axios.create({
  baseURL: "/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

const AUTH_HEADERS = ["access-token", "client", "uid", "expiry", "token-type"];

client.interceptors.request.use((config) => {
  AUTH_HEADERS.forEach((header) => {
    const value = localStorage.getItem(`auth_${header}`);
    if (value) {
      config.headers[header] = value;
    }
  });
  return config;
});

client.interceptors.response.use(
  (response) => {
    AUTH_HEADERS.forEach((header) => {
      const value = response.headers[header];
      if (value) {
        localStorage.setItem(`auth_${header}`, value);
      }
    });
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      AUTH_HEADERS.forEach((header) => {
        localStorage.removeItem(`auth_${header}`);
      });
      localStorage.removeItem("auth_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const clearAuthHeaders = () => {
  AUTH_HEADERS.forEach((header) => {
    localStorage.removeItem(`auth_${header}`);
  });
  localStorage.removeItem("auth_user");
};

export default client;
